import { BasicEntity } from "../../core/models/basic-entity";

export class Currency extends BasicEntity {
    public Symbol?:string;
}
